const attachmentMergesStyles = {
  button: { margin: "1rem auto", width: 300, display: "block", textAlign: "center" },
  placeholderBox: {
    width: 200,
    height: 200,
    border: "1px solid #333333",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};
export default attachmentMergesStyles;
